 import { FiArrowUpRight } from "react-icons/fi";
import { useMediaQuery } from "react-responsive";
 
const services = [
  { 
    title: "Content & Creative", 
    description: "Stand out with impactful visuals.",
    link: "/digital-marketing/services/content-creative"
  },
  { 
    title: "Paid Media & Performance", 
    description: "Maximize ROI from every campaign.",
    link: "/digital-marketing/services/paid-media-performance"
  },
  { 
    title: "Analytics & Insights", 
    description: "Track, analyze, and optimize results.",
    link: "/digital-marketing/services/analytics-insights"
  }
];

const ServicesCards = () => {

  const isDesktop = useMediaQuery({ minWidth: 768 });

 
  
  return (
    <div className="services__cards-container">
      {services.map((service, index) => (
        <a 
         
          key={index} 
          href={service.link} 
          className={`service__card ${
            index === 2 && isDesktop ? "full-width" : ""
          }`}
              >
          <h3>{service.title}</h3>
          <div className="service-bottom">
            <p>{service.description}</p>
            <div className="card-arrow">
              <FiArrowUpRight />
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default ServicesCards;
